import { useCallback } from 'react';

export const useOpenPricingWindowCallback = (): (() => void) => {
    return useCallback(() => {
        window.open('/pricing', `Pricing-${window.channelId}`, 'popup,width=500,height=800');
    }, []);
};
